(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("../../components/BlockFormControlLayout"), require("../../components/Icon"));
	else if(typeof define === 'function' && define.amd)
		define(["../../components/BlockFormControlLayout", "../../components/Icon"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("../../components/BlockFormControlLayout"), require("../../components/Icon")) : factory(root["../../components/BlockFormControlLayout"], root["../../components/Icon"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function(__WEBPACK_EXTERNAL_MODULE__662__, __WEBPACK_EXTERNAL_MODULE__20__) {
return 